const localStorage = window.localStorage
let localStorageCache

try {
  localStorage.getItem('test')

  localStorageCache = {
    getItem: function (item) {
      return JSON.parse(localStorage.getItem(item))
    },
    setItem: function (item, value) {
      value = JSON.stringify(value)
      try {
        localStorage.setItem(item, value)
      } catch (e) {
        // storage full
        localStorage.clear()
        localStorage.setItem(item, value)
      }
    },
    getItemAndRemove: function (item) {
      const content = JSON.parse(localStorage.getItem(item))
      localStorage.removeItem(item)
      return content
    }
  }
} catch (e) {
  localStorageCache = {
    getItem: () => {},
    setItem: () => {},
    getItemAndRemove: () => {}
  }
}

export default localStorageCache
